import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import asyncRouter from '@/store/modules/async-router';
import common from '@/store/modules/common';
import order from '@/store/modules/order';
import price from '@/store/modules/price';
import show from '@/store/modules/show';
import user from '@/store/modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['user.token', 'price.priceDetail'],
    }),
  ],

  state: {},

  mutations: {},

  actions: {},

  modules: {
    asyncRouter,
    user,
    show,
    common,
    order,
    price,
  },
});
